import { atom } from 'jotai'
import { DateTime } from 'luxon'

import { currentEnv } from '@/env/vars.ts'
import { queryClient } from '@/QueryClient'
import { store } from '@/store'
import { IApproval, ICompliance } from '@/types/tasksApprovals'
import { GET, IGetOptions } from '@/utils/fetch'

import { setApprovalsInfo, setCompliancesInfo } from './utils'

export const approvalsAtom = atom<IApproval[]>([])
export const compliancesAtom = atom<ICompliance[]>([])

export const compliancesTotalAtom = atom(0)
export const approvalsTotalAtom = atom(0)

export const isExpandedAtom = atom(false)

export const toggleMobiledrawer = () => {
    store.set(isExpandedAtom, !store.get(isExpandedAtom))
}

export const getApprovals = async (disableCache?: boolean) => {
    const options: IGetOptions = { hideError: true }
    if (disableCache) {
        options.cacheControl = 'no-cache'
    }
    const res = await queryClient.fetchQuery({
        queryKey: ['approvals'],
        queryFn: () => GET<IApproval[]>(`${currentEnv.approvalsUrl}/approvals`, options),
    })
    if (res) {
        const result = setApprovalsInfo(res)
        store.set(approvalsTotalAtom, res.length)
        store.set(
            approvalsAtom,
            result.sort((a, b) => {
                return DateTime.fromISO(b.approval_requested_at).toMillis() >= DateTime.fromISO(a.approval_requested_at).toMillis() ? 1 : -1
            }),
        )
    }
}

export const getCompliances = async (disableCache?: boolean) => {
    const options: IGetOptions = { hideError: true }
    if (disableCache) {
        options.cacheControl = 'no-cache'
    }
    const res = await queryClient.fetchQuery({
        queryKey: ['tasks'],
        queryFn: () => GET<ICompliance[]>(`${currentEnv.approvalsUrl}/compliances`, options),
    })

    if (res) {
        const result = setCompliancesInfo(res)
        store.set(compliancesTotalAtom, res.length)
        store.set(compliancesAtom, result)
    }
}
;(() => {
    setInterval(
        () => {
            void getApprovals()
        },
        2 * 60 * 1000, // 2 minutes
    )
    setInterval(
        () => {
            void getCompliances()
        },
        5 * 60 * 1000, // 5 minutes
    )
})()
